module.exports = __webpack_public_path__ + "static/zivotdetem-acd2de42f7ab60e1d50f60855a2fa56c.png";